import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

import {
  AreaChart,
  Area,
  Brush,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

import {
  getPonctualiteDayRTL,
  getPonctualiteDay,
  getAllAgencies,
  getUser, getUserAgency
} from '../API';

import optc from '../optc.json'

import { useTranslation } from "react-i18next";

function PonctualiteJour() {

  const [t] = useTranslation('common');

  const [user, setUser] = useState('');
  const [agency, setAgency] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [service, setService] = useState("SE");
  const [period, setPeriod] = useState('all');
  const [direction, setDirection] = useState('all');

  const [ponctualiteArray, setPonctualiteArray] = useState([]);
  const [range, setRange] = useState({ startIndex: 0, endIndex: 0 });
  const [poncAvg, setPoncAvg] = useState(0);
  const [lateAvg, setLateAvg] = useState(0);
  const [earlyAvg, setEarlyAvg] = useState(0);

  const [refreshKey, setRefreshKey] = useState(0);

  const [loading, setLoading] = useState(0);

  useEffect(() => {
    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setUserAgency(response);
      })
  }, []);


  useEffect(() => {
    setLoading(1);

    getPonctualiteDay(agency, service, period, direction)
      .then(response => {
        setPonctualiteArray(response);
        setRange({ startIndex: 0, endIndex: response.length - 1 })
        let sumPonc = 0;
        let sumLate = 0;
        let sumEarly = 0;
        sumPonc = response
          .reduce((acc, obj) => {
            return (acc + obj.ponctuel)
          }, 0)
        sumLate = response
          .reduce((acc, obj) => {
            return (acc + obj.retard)
          }, 0)
        sumEarly = response
          .reduce((acc, obj) => {
            return (acc + obj.avance)
          }, 0)
        setPoncAvg(sumPonc / (response.length - 1) * 100);
        setLateAvg(sumLate / (response.length - 1) * 100);
        setEarlyAvg(sumEarly / (response.length - 1) * 100);
        setLoading(0);
      });

  }, [refreshKey]);


  async function handleServiceClick(e) {

    if (e.target.innerHTML == t('dailyotp.week')) {
      setService('SE')
    } else if (e.target.innerHTML == t('dailyotp.sat')) {
      setService('SA')
    } else {
      setService('DI')
    }
    setRefreshKey(oldKey => oldKey + 1);
  }

  const handlePeriodClick = (e) => {
    if (e.target.innerHTML == t('compareperiods.all')) {
      setPeriod("all")
    } else if (e.target.innerHTML == t('compareperiods.morning')) {
      setPeriod("morning")
    } else if (e.target.innerHTML == t('compareperiods.am')) {
      setPeriod("am")
    } else if (e.target.innerHTML == t('compareperiods.offpeak')) {
      setPeriod("offpeak")
    } else if (e.target.innerHTML == t('compareperiods.pm')) {
      setPeriod("pm")
    } else {
      setPeriod("evening")
    }

    setRefreshKey(oldKey => oldKey + 1);
  }

  const handleDirectionClick = (e) => {

    if (e.target.innerHTML == t('tripotp.out')) {
      let dir = optc.optc.find((e) => e.operateur == userAgency).inOut[1];
      setDirection(dir);
    } else if (e.target.innerHTML == t('tripotp.in')) {
      let dir = optc.optc.find((e) => e.operateur == userAgency).inOut[0];
      setDirection(dir);
    } else {
      setDirection('all');
    }
    setRefreshKey(oldKey => oldKey + 1);
  }

  async function handleAgencySelect(e) {
    setAgency(e.target.value);
    setRefreshKey(oldKey => oldKey + 1);
  }

  const handleBrushChange = (newRange) => {
    let sumPonc = 0;
    let sumLate = 0;
    let sumEarly = 0;
    setRange(newRange);
    if (newRange) {
      sumPonc = (ponctualiteArray.slice(range.startIndex, range.endIndex)
        .reduce((acc, obj) => {
          return (acc + obj.ponctuel)
        }, 0))
      sumLate = (ponctualiteArray.slice(range.startIndex, range.endIndex)
        .reduce((acc, obj) => {
          return (acc + obj.retard)
        }, 0))
      sumEarly = (ponctualiteArray.slice(range.startIndex, range.endIndex)
        .reduce((acc, obj) => {
          return (acc + obj.avance)
        }, 0))
      setPoncAvg(sumPonc / (range.endIndex - range.startIndex) * 100);
      setLateAvg(sumLate / (range.endIndex - range.startIndex) * 100);
      setEarlyAvg(sumEarly / (range.endIndex - range.startIndex) * 100);
    }
  };

  const toPercent = (decimal) => `${(decimal * 100).toFixed(0)}%`;

  // const renderTooltipContent = (o) => {
  //   const { payload, label } = o;
  //   const total = payload.reduce((result, entry) => result + entry.value, 0);
  // }

  const CustomTooltip = ({ active, payload }) => {
    if (active, payload) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            {payload[0] ? payload[0].payload.date : ''} <br />
            {t('dailyotp.hover.early')} {payload[0] ? (payload[0].payload.avance * 100).toFixed(0) : ''}% <br />
            {t('dailyotp.hover.late')} {payload[0] ? (payload[0].payload.retard * 100).toFixed(0) : ''}% <br />
            {t('dailyotp.hover.ontime')} {payload[0] ? (payload[0].payload.ponctuel * 100).toFixed(0) : ''}%
          </p>
        </div>
      );
    }
    return null;
  }


  return (
    ponctualiteArray && userAgency ?
      <>

        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm"></div>
          <h1 id="page-title" className="display-5">{t('dailyotp.title')}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="row justify-content-center pt-3">

            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-center">
              <div className="me-1 border rounded ps-2 pe-2 pt-4 pb-4" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center align-items-center">

                  {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="col-lg-4">
                    <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-xl mb-3 mt-3">
                      <option defaultValue>Opérateur</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div> : ''}

                  <h4>{t('datatable.days')}</h4>
                  {/* <div className="col text-center pb-2"> */}
                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 text-center pb-2">
                    <div type="button" className={service == "SE" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.week')}</div>
                    <div type="button" className={service == "SA" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sat')}</div>
                    <div type="button" className={service == "DI" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sun')}</div>
                  </div>



                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center pt-3">

            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-center">
              <div className="me-1 border rounded ps-2 pe-2 pt-4 pb-4" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center align-items-center">

                  <h4>{t('datatable.period')}</h4>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center pb-2">
                    <div type="button" className={period == "all" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.all')}</div>
                    <div type="button" className={period == "morning" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.morning')}</div>
                    <div type="button" className={period == "am" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.am')}</div>
                    <div type="button" className={period == "offpeak" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.offpeak')}</div>
                    <div type="button" className={period == "pm" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.pm')}</div>
                    <div type="button" className={period == "evening" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(e) => handlePeriodClick(e)}>{t('compareperiods.evening')}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* <div className="row justify-content-center pt-3">

            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-center">
              <div className="me-1 border rounded ps-2 pe-2 pt-4 pb-4" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center align-items-center">

                  <h4>{t('datatable.period')}</h4>

                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center pb-2">
                    <div type="button" className={direction == 'all' ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleDirectionClick(event)}>{t('compareperiods.all')}</div>
                    <div type="button" className={direction == optc.optc.find((e) => e.operateur == userAgency).inOut[1] ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleDirectionClick(event)}>{t('tripotp.out')}</div>
                    <div type="button" className={direction == optc.optc.find((e) => e.operateur == userAgency).inOut[0] ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleDirectionClick(event)}>{t('tripotp.in')}</div>
                  </div>

                </div>
              </div>
            </div>
          </div> */}

          <div>
            <div className="col text-center pt-4">
              <h3>{t('vehdays.from') + ponctualiteArray[range.startIndex]?.date + t('vehdays.to') + ponctualiteArray[range.endIndex]?.date}</h3>
            </div>
            <div className="col text-center pt-4">
              <h3>{t('compareperiods.kpi.otp') + ' ' + poncAvg.toFixed(1) + '%'}</h3>
              <h5>{t('dailyotp.hover.late') + ' ' + lateAvg.toFixed(1) + '%'}</h5>
              <h5>{t('dailyotp.hover.early') + ' ' + earlyAvg.toFixed(1) + '%'}</h5>
            </div>
          </div>

          <div className="row justify-content-center pt-2 pb-4">
            <div className="col-lg col-sm-12 pt-3">
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                {/* <div className="row text-center mb-2 pt-3">
                  <h4>Points récupérés aux 90 secondes</h4>
                </div> */}

                {loading == 0 ? '' :
                  <div className="ponctualitespinner">
                    <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
                  </div>}

                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-12 text-center" style={{ touchAction: "none" }}>

                    <ResponsiveContainer width="100%" height={450}>
                      <AreaChart
                        width={500}
                        height={50}
                        data={ponctualiteArray}
                        stackOffset="expand"
                        margin={{
                          top: 10,
                          right: 30,
                          left: 30,
                          bottom: 0,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" angle={-90} dx={-4} textAnchor="end" height={100} />
                        <YAxis tickFormatter={toPercent} />
                        <Tooltip
                          filterNull={false}
                          content={<CustomTooltip />} />
                        <Legend formatter={(value, entry, index) =>
                          <span style={{ color: "black" }} className="text-color-class">{value}</span>
                        } />
                        <Area type="monotone" name={t('dailyotp.legend.ontime')} dataKey="ponctuel" stackId="1" stroke="#0c8912" fill="#0c8912" isAnimationActive={false} />
                        <Area type="monotone" name={t('dailyotp.legend.late')} dataKey="retard" stackId="1" stroke="#eeda04" fill="#eeda04" isAnimationActive={false} />
                        <Area type="monotone" name={t('dailyotp.legend.early')} dataKey="avance" stackId="1" stroke="#e1341e" fill="#e1341e" isAnimationActive={false} />
                        <Brush
                          dataKey="name"
                          height={30}
                          stroke="#4d0077"
                          onChange={handleBrushChange}
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </> :
      <>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </>
  )
}

export default PonctualiteJour